<template>

    <div class="component-container">

        <div class="er-bloc-login">

            <div class="bloc-login-separator">

                <h1 class="title-login"
                >{{ pageTitle }}</h1>

                <span class="subtitle">{{ $t('login_email_secure') }}</span>

                <input-text ref="inputEmail"
                            :big="true"
                            :data="loginEmail"
                            :placeholder="$t('login_email_placeholder')"
                            :type="'email'"
                            :error="error"
                            class="er-input-text"
                            @change="testEmail"
                            @pressEnter="next"
                ></input-text>

                <div v-show="error" class="error">
                    <span>{{ errorLK }}</span>
                </div>

                <button
                    :class="{ 'btn-disable': isNotValidEmail }"
                    class="btn btn-blue btn-big er-btn"
                    @click="next"
                >{{ $t('global_cta_next') }}
                </button>

            </div>

            <p class="er-secu">{{ $t('login_email_disclaimer') }}</p>

        </div>

        <page-loader ref="loader"></page-loader>

        <modal-error-provider ref="MEP" :email="emailError" :provider="provider"></modal-error-provider>

    </div>

</template>

<script>

import Vuex from 'vuex'

import Api from '../../api'

import SessionStorage from '../../helpers/sessionStorage'

import InputText from '../../components/inputs/InputText'
import ModalErrorProvider from '../../components/modal/ModalErrorProvider'
import PageLoader from '../../components/PageLoader'
import HeaderBand from '../../components/headers/HeaderBand'

import Tag from '@/modules/tag'

export default {

    name: 'login',

    components: {
        HeaderBand,
        InputText,
        ModalErrorProvider,
        PageLoader
    },

    props: {

        directDeleteAccount: {
            type: Boolean,
            default: false
        }

    },

    computed: {

        ...Vuex.mapGetters(['user', 'isConnected']),

        loginEmail() {
            return SessionStorage.getItem('email')
        },

        pageTitle() {
            return this.directDeleteAccount
                ? this.$t('email_address_cleanfox')
                : this.$t('login_title')
        }
    },

    data() {
        return {
            error: false,
            errorLK: '',
            regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            isNotValidEmail: true,
            emailError: '',
            provider: ''
        }
    },

    mounted() {

        this.$refs.inputEmail.focus()

    },

    methods: {

        ...Vuex.mapActions([
            'setEmail',
            'updateEmailToDeleteRedirect'
        ]),

        next() {
            this.error = false

            Tag.clickAmplitude(this, 'next')

            const email = this.$refs.inputEmail.value

            SessionStorage.setItem('email', email)

            if (this.regexMail.test(email) && email.length > 0) {

                this.$refs.loader.start()
                this.provider = ''
                Api.provider.get(email)
                    .then(data => {

                        Tag.infoAmplitude(this, 'login_email_provider', data.provider)

                        if (this.directDeleteAccount) {
                            this.redirectToDeleteFlow(data, email)
                        } else {
                            this.defaultRedirectFlow(data, email)
                        }

                    })
                    .catch(error => {

                        this.$refs.loader.stop()
                        this.errorFlow(error)
                    })
            }
        },

        showMEPError(error, email) {
            this.emailError = email
            if (error.data) {
                this.provider = error.data.provider || ''
            }
            this.$refs.MEP.show(error)
        },

        testEmail: function () {

            const email = this.$refs.inputEmail.value

            if (email.length > 0) {
                this.isNotValidEmail = !this.regexMail.test(email)

            } else {
                this.isNotValidEmail = true
            }
        },

        redirectToDeleteFlow(data, email) {
            if ('invalidGrant' in data) {
                // if account exist in database
                let path = '/'

                this.updateEmailToDeleteRedirect(email)
                const emailIsFromUserAccounts = this.user && this.user.accounts && this.user.accounts.some(account => account.email.localeCompare(email) === 0)
                if (this.isConnected && emailIsFromUserAccounts) {
                    path = '/settings'

                } else {
                    SessionStorage.setItem('email', email)
                    path = data.invalidGrant
                        ? `/login/${data.provider}`
                        : '/magic-request-email'
                }

                this.goPath(path, data.invalidGrant)

            } else {
                this.errorFlow({message: 'delete_account_not_in_database'}, email)
            }
        },

        defaultRedirectFlow(data) {
            switch(data.invalidGrant) {
                case true:
                    this.goPath(`/login/${data.provider}`, data.invalidGrant)
                    break
                case false:
                    this.goPath('/magic-request-email')
                    break
                default:
                    this.goPath(`/login/${data.provider}`)
                    break
            }
        },

        goPath(path, invalidGrant) {
            this.$router.push({
                path,
                query: {
                    'ig': invalidGrant
                }
            }).catch(() => {})
        },

        errorFlow(error, email) {
            this.$refs.loader.stop()
            switch (error.message) {
                case 'mx_unsupported':
                case 'mx_not_found':
                    this.showMEPError(error, email)
                    break
                case 'login_email_already_associated':
                case 'delete_account_not_in_database':
                    this.error = true
                    this.errorLK = this.$t(error.message)
                    break
            }
        }


    }
}
</script>

<style lang="scss" scoped>

.component-container {
    display: flex;
    flex-grow: 1;
    @media screen and (min-width: $above-tablet-length) {
        align-items: center;
    }
}

.bloc-login-separator {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .error {
        width: 100%;
        margin-top: 5px;
        font-size: 15px;
        line-height: 1.33;
        text-align: start;
        color: $raspberry;
    }
}

.er-bloc-login {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 501px;
        border-radius: 8px;
        box-shadow: 0 1px 6px 1px rgba(0, 0, 0, 0.15);
        background-color: $white;
        padding: 42px 24px 25px;
        height: fit-content;
    }
}

.title-login {
    margin-top: 33px;
    font-size: 22px;
    font-weight: bold;
    line-height: 1.27;
    letter-spacing: -0.2px;
    color: $midnight;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 0;
        font-size: 32px;
        font-weight: bold;
        line-height: 1.25;
    }
}

.subtitle {
    margin-top: 14px;
    font-size: 12px;
    font-weight: 500;
    color: $grey;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 13px;
        font-size: 17px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.41;
        letter-spacing: normal;
        text-align: center;
        color: $grey;
    }
}

.er-input-text {
    margin-top: 28px;
    width: 100%;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 41px;
    }
}

.er-btn {
    margin-top: 16px;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 275px;
    }
}

.er-secu {
    font-size: 11px;
    line-height: 1.45;
    color: $midnight;
    margin: 18px 0;
    left: 16px;
    right: 16px;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 213px;
    }
}

</style>
